<script setup lang="ts">
import { computed } from 'vue';
import {
	PinInputRoot,
	type PinInputRootEmits,
	useForwardPropsEmits
} from 'radix-vue';
import type { PinInputProps } from '.';
import { cn } from '@/utils';

const props = withDefaults(defineProps<PinInputProps>(), {
	modelValue: () => []
});
const emits = defineEmits<PinInputRootEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;
	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<PinInputRoot
		v-bind="forwarded"
		:class="cn('flex items-center gap-2', props.class)"
	>
		<slot></slot>
	</PinInputRoot>
</template>
